import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import {
  // Alert, Button, CircularProgress, Divider, Drawer, Link, Typography
  IconButton,
} from '@mui/material';
// import { makeStyles } from '@mui/styles';
import {
  // alpha,
  styled
} from '@mui/material/styles';
import { Box } from '@mui/material';
// import { isMobile } from '../../../../helpers/deviceDetect';
// import MarCapFilter from '../../ScreenFilters/MarCapField';

const QuickSearchField = styled((props) => (
  <TextField
    {...props}
  />
))(({ theme }) => ({
  [theme.breakpoints.down('xs')]: {
    width: '100%',
  },
  margin: '0 12px 4px 12px',
  '& .MuiSvgIcon-root': {
    marginRight: '4px',
    color: 'hsl(235deg 59.62% 21.27%)' /*#020B4A*/
  },
  '& .MuiInputBase-input-MuiInput-input:hover': {
    background: '#f0f1f4',
  },
  border: `1px solid hsla(216, 41%, 87%, 0.8)`,
  borderRadius: '4px',
  // minWidth: theme.breakpoints.down('xs') ? '17rem' : '100%',
  [theme.breakpoints.down('md')]: {
    minWidth: '14rem',
  },
  [theme.breakpoints.up('md')]: {
    minWidth: '17rem',
  },
  [theme.breakpoints.up('lg')]: {
    minWidth: '22rem',
  },
  '& .Mui-focused': {
    background: '#fff',
    borderRadius: '4px',
  },
  '& .MuiInput-underline:before': {
    padding: '4px',
    border: `0 !important`,
  },
  '& .MuiInput-underline:after': {
    // border: `1px solid ${theme.palette.text.link}`,
    border: `0 !important`,
  },
  '& .MuiInputBase-input-MuiInput-input': {
    fontSize: '.8rem !important',
  },
  '& .MuiInputBase-root-MuiInput-root:hover:not(.Mui-disabled):before': {
    background: '#fff',
  }
}));

const TableToolbar = (props) => {
  const {
    //  getScreeners, setLoading, setMarketCap, marketCap, isLoading, estimatedResults, conditions, ScreenerFilters, Presets,
    menu, tableName, manageColumns, saveScreener, download, results, pagination,
  } = props || {}
  // const [state, setState] = React.useState({
  //   bottom: false,
  //   right: false,
  // });

  // const toggleDrawer = (anchor, open) => (event) => {
  //   if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
  //     return;
  //   }

  //   setState({ ...state, [anchor]: open });
  // };

  // const list = (anchor) => (
  //   <Box
  //     sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
  //     role="presentation"
  //     onClick={toggleDrawer(anchor, false)}
  //     onKeyDown={toggleDrawer(anchor, false)}
  //   >
  //     test
  //   </Box>
  // );

  return (
    <>
      {/* <Divider sx={{ my: 1 }} /> */}
      {tableName}
      <Box
        sx={{
          // mt: 2,
          mb: .7, pb: .7,
          // justifyContent: 'space-between',
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          borderBottom: '1px solid rgb(229, 234, 242)',
          // flexDirection: { md: 'row-reverse', sm: 'row-reverse', xs: 'row' },
          // mb: 3
        }}
      >
        {/* <Box>
          <Box
            sx={{
              justifyContent: 'space-between',
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
              my: 2,
            }}
          >
            <Typography variant="subtitle1" gutterBottom component="div" sx={{ padding: "0 16px", fontWeight: '600', mb: 0 }}>
              {`Matching Stocks`}
            </Typography>
            <Alert
              severity="info"
              sx={{
                backgroundColor: '#fff',
                // color: 'rgb(255, 167, 38)',
                color: '#5b636a9c',
                py: 0,
                padding: { md: "0", xs: '0 16px' },
                '& .MuiAlert-icon': {
                  fontSize: 18,
                  alignItems: 'center',
                  color: 'rgb(255, 167, 38)',
                  py: 0,
                },
                '& .MuiAlert-message': {
                  py: 0,
                }
              }}
            >
              {`Drag and arrange columns according to your preference!`}
            </Alert>
          </Box>
        </Box> */}
        {/* <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <MarCapFilter getScreeners={getScreeners} setLoading={setLoading} setMarketCap={setMarketCap} marketCap={marketCap} inline={true} />
        </Box> */}
        {/* {tableName} */}
        {/* <Box sx={{ display: 'flex', mb: { xs: 2 } }}> */}
        <QuickSearchField
          variant="standard"
          value={props.value}
          onChange={props.onChange}
          placeholder="Search any ticker or keywoard"
          className="searchField"
          InputProps={{
            startAdornment: <SearchIcon fontSize="small" sx={{ ml: 1 }} />,
            endAdornment: (
              <IconButton
                title="Clear"
                aria-label="Clear"
                size="small"
                style={{ visibility: props.value ? 'visible' : 'hidden' }}
                onClick={props.clearSearch}
                sx={{ '& .MuiSvgIcon-fontSizeSmall': { marginRight: '0 !important' } }}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            ),
          }}
          sx={{
            // mr: 2,
            // mt: 2,
            background: '#fff',
            '&.MuiTextField-root.searchField': {
              m: '0px 12px 0px 12px',
            },
            '& .MuiSvgIcon-root': {
              fontSize: '1.1rem',
            },
            '& .MuiInputBase-input::placeholder': {
              fontSize: '.87rem',
            },
            '& .MuiInputBase-input': {
              fontSize: '.87rem',
              padding: '7px'
            },
            position: props.searchPosAbsolute ? { xs: 'static', md: 'absolute' } : '',
            top: props.searchPosAbsolute ? 13 : '',
            right: props.searchPosAbsolute ? 0 : ''
          }}
        />
        {manageColumns}
        {/* {saveScreener} */}
        {download}
        {pagination}
        {/* {menu} */}
        {/* {ScreenerFilters} */}
        {/* </Box> */}
      </Box>
      {/* <Drawer
        anchor={'right'}
        open={state['right']}
        onClose={toggleDrawer('right', false)}
      >
        {list('right')}
      </Drawer> */}
    </>
  );
}

TableToolbar.propTypes = {
  clearSearch: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default TableToolbar;
